// DevTools disabler for production
export const disableDevTools = () => {
  const isDisabled = process.env.REACT_APP_DISABLE_DEVTOOLS === 'true';
  
  if (!isDisabled) {
    console.log('🔧 DevTools protection disabled in development mode');
    return;
  }

  console.log('🛡️ DevTools protection enabled for production');

  // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  document.addEventListener('keydown', function(e) {
    // F12
    if (e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+I (Inspector)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+U (View Source)
    if (e.ctrlKey && e.keyCode === 85) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+C (Element Selector)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+S (Save Page)
    if (e.ctrlKey && e.keyCode === 83) {
      e.preventDefault();
      return false;
    }
  });

  // Disable right-click context menu
  document.addEventListener('contextmenu', function(e) {
    e.preventDefault();
    return false;
  });

  // Disable text selection
  document.addEventListener('selectstart', function(e) {
    e.preventDefault();
    return false;
  });

  // Disable drag and drop
  document.addEventListener('dragstart', function(e) {
    e.preventDefault();
    return false;
  });

  // Clear console periodically
  if (isDisabled) {
    setInterval(() => {
      console.clear();
    }, 5000);
  }

  // Detect DevTools opening (basic detection)
  let devtools = {
    open: false,
    orientation: null
  };
  
  const threshold = 160;
  
  setInterval(() => {
    if (window.outerHeight - window.innerHeight > threshold || 
        window.outerWidth - window.innerWidth > threshold) {
      if (!devtools.open) {
        devtools.open = true;
        console.clear();
        // Optionally redirect or show warning
        // window.location.reload();
      }
    } else {
      devtools.open = false;
    }
  }, 500);

  // Override console methods in production
  if (isDisabled) {
    const noop = () => {};
    
    // Save original methods
    const originalMethods = {
      log: console.log,
      error: console.error,
      warn: console.warn,
      info: console.info,
      debug: console.debug
    };
    
    // Override console methods
    console.log = noop;
    console.error = noop;
    console.warn = noop;
    console.info = noop;
    console.debug = noop;
    console.group = noop;
    console.groupEnd = noop;
    console.table = noop;
    console.trace = noop;
    console.time = noop;
    console.timeEnd = noop;
    
    // For critical errors, still allow them in a limited way
    window.criticalError = originalMethods.error;
  }
};

export default disableDevTools;
